<script lang="ts">
  import type { TaxTypes } from "../enums";
  import { filterLabels } from "../lang";
  import {
    getRegionOptions,
    getStateOptions,
    getTaxOptions,
    getYearOptions,
  } from "../lib/filter";
  import type { Dataset, Datasets, State } from "../types";
  import Autosuggest from "./Autosuggest.svelte";
  import CheckboxGroup from "./CheckboxGroup.svelte";
  import Fieldset from "./Fieldset.svelte";
  import Select from "./Select.svelte";
  import Table from "./Table.svelte";

  export let datasets: Datasets;

  $: stateOptions = getStateOptions(datasets);
  let state: State;

  $: regionOptions = getRegionOptions(state);
  $: showRegions = regionOptions?.length;
  let region: Dataset;

  $: yearOptions = getYearOptions(datasets);
  let years: number[] = [];

  const taxOptions = getTaxOptions();
  let taxes: TaxTypes[] = [];

  $: showTables = state && years.length && taxes.length;
  $: tableTitle = region ? region.name : state?.data?.name;

  function resetRegion() {
    region = null;
  }
</script>

<div class="u-mbe-32 u-space-b-32">
  <div class="u-size-i-350">
    <Select
      label={filterLabels.state}
      options={stateOptions}
      bind:value={state}
      on:change={resetRegion}
    />
  </div>

  {#if showRegions}
    <div class="u-size-i-350">
      <Autosuggest
        label={filterLabels.region}
        options={regionOptions}
        bind:value={region}
        on:clear={resetRegion}
      />
    </div>
  {/if}

  <Fieldset legend={filterLabels.years}>
    <CheckboxGroup
      items={yearOptions}
      bind:group={years}
      --columns="repeat(auto-fill, minmax(8ch, 1fr))"
    />
  </Fieldset>

  <Fieldset legend={filterLabels.taxes}>
    <CheckboxGroup items={taxOptions} bind:group={taxes} />
  </Fieldset>
</div>

{#if showTables}
  <h2 class="u-mbe-20">Daten für {tableTitle}</h2>
  <div class="u-space-b-32">
    {#each taxes as tax}
      <Table {tax} total={datasets} {state} {region} {years} />
    {/each}
  </div>
{/if}
